import { __decorate } from "tslib";
import "element-internals-polyfill";
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { live } from "lit/directives/live.js";
import { styleMap } from "lit/directives/style-map.js";
let InputEditorInlineElement = class InputEditorInlineElement extends LitElement {
    get liveValue() {
        var _a;
        return (_a = this._inputElement) === null || _a === void 0 ? void 0 : _a.value;
    }
    constructor() {
        super();
        this.required = false;
        this.disabled = false;
        this.type = "text";
    }
    disable(isDisable = true) {
        this.disabled = isDisable;
    }
    keyup(evt) {
        if (evt.key === "Enter") {
            this.dispatchEvent(new CustomEvent("editorKeyEnter", { bubbles: true, composed: true, detail: { editor: this } }));
        }
    }
    valueChanged() {
        this.dispatchEvent(new CustomEvent("valueChanged", { bubbles: true, composed: true, detail: { editor: this } }));
    }
    updateValue(event) {
        if (this._inputElement.checkValidity())
            this._inputElement.classList.remove("invalid");
        else
            this._inputElement.classList.add("invalid");
        this.dispatchEvent(new CustomEvent("editorChanged", { bubbles: true, composed: true, detail: { editor: this } }));
    }
    async reportValidity() {
        if (this._inputElement.reportValidity()) {
            this._inputElement.classList.remove("invalid");
            return true;
        }
        else {
            this._inputElement.classList.add("invalid");
            return false;
        }
    }
    setCustomValidity(error) {
        this._inputElement.setCustomValidity(error);
    }
    firstUpdated() { }
    cancel() {
        this._inputElement.classList.remove("invalid");
        this.requestUpdate();
    }
    render() {
        const font = { font: this.editorSize === "small" ? "var(--font-input-small)" : "var(--font-input)" };
        return html `
            <input
                id="input"
                name="${this.name}"
                style="${styleMap({ ...font, width: this.inputWidth })}"
                type="${this.type}"
                .value="${live(this.value)}"
                @input="${this.updateValue}"
                @change="${this.valueChanged}"
                @keyup="${this.keyup}"
                maxlength="${ifDefined(this.maxlength)}"
                minlength="${ifDefined(this.minlength)}"
                size="${ifDefined(this.size)}"
                pattern="${ifDefined(this.pattern)}"
                placeholder="${ifDefined(this.placeholder)}"
                ?required="${this.required}"
                ?disabled="${this.disabled}"
            />
        `;
    }
};
InputEditorInlineElement.styles = css `
        :host([hidden]) {
            display: none;
        }
        :host {
            display: block;
        }
        input.invalid {
            outline: 2px solid pink;
        }
        #input {
            box-sizing: border-box;
            font: var(--font-input);
            border-radius: 8px;
            border: 1px solid var(--color-gray-4);
            padding: 8px 12px;
            width: 100%;
        }
        #input:disabled {
            color: gray;
        }
    `;
__decorate([
    property()
], InputEditorInlineElement.prototype, "value", void 0);
__decorate([
    property({ type: Number })
], InputEditorInlineElement.prototype, "size", void 0);
__decorate([
    property({ type: Number })
], InputEditorInlineElement.prototype, "minlength", void 0);
__decorate([
    property({ type: Number })
], InputEditorInlineElement.prototype, "maxlength", void 0);
__decorate([
    property()
], InputEditorInlineElement.prototype, "pattern", void 0);
__decorate([
    property()
], InputEditorInlineElement.prototype, "placeholder", void 0);
__decorate([
    property({ attribute: "input-width" })
], InputEditorInlineElement.prototype, "inputWidth", void 0);
__decorate([
    property({ type: Boolean })
], InputEditorInlineElement.prototype, "readonly", void 0);
__decorate([
    property({ type: Boolean })
], InputEditorInlineElement.prototype, "required", void 0);
__decorate([
    property({ type: Boolean })
], InputEditorInlineElement.prototype, "disabled", void 0);
__decorate([
    property()
], InputEditorInlineElement.prototype, "name", void 0);
__decorate([
    property()
], InputEditorInlineElement.prototype, "type", void 0);
__decorate([
    property({ attribute: "editor-size" })
], InputEditorInlineElement.prototype, "editorSize", void 0);
__decorate([
    query("#input")
], InputEditorInlineElement.prototype, "_inputElement", void 0);
InputEditorInlineElement = __decorate([
    customElement("se-input-inline-editor")
], InputEditorInlineElement);
export { InputEditorInlineElement };
//# sourceMappingURL=input-editor.element.js.map